import React from 'react';
import styled from 'styled-components';

import ContentBox from '../contentBox/ContentBox';
import Switch from '../switch/Switch';

const SetStyled = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;

    margin-bottom: 40px;

    &:last-child {
        margin-bottom: 0;
    }
`;

const Subtitle = styled.div`
    border-bottom: 2px solid ${props => props.theme.content.color};
    color: ${props => props.theme.content.color};
    text-transform: uppercase;
    margin-bottom: 30px;
    padding-bottom: 10px;
    font-size: 16px;
`;

const Set = ({
    list,
    title = false,
    add,
    remove,
    addPurpose,
    removePurpose,
}) => {
    return (
        <React.Fragment>
            {title && <Subtitle>{title}</Subtitle>}
            {list.map((e, i) => {
                return (
                    <SetStyled key={i}>
                        <Switch
                            isOn={e.isOn}
                            disabled={e.disabled}
                            id={e.id}
                            add={add}
                            remove={remove}
                            addPurpose={addPurpose}
                            removePurpose={removePurpose}
                        ></Switch>
                        <ContentBox name={e.name} description={e.description}></ContentBox>
                    </SetStyled>
                )
            })}
        </React.Fragment>
    );
};

export default Set;